import { useTranslation } from 'react-i18next';

import { FormLayout } from '@/components/common/FormLayout';
import { PageLayout } from '@/components/common/PageLayout';
import { RegisterForm } from '@/components/register/RegisterForm';

export default function RegisterIndex() {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <FormLayout title={t('auth.register.title')}>
        <RegisterForm />
      </FormLayout>
    </PageLayout>
  );
}
